export const SENT_ESTIMATE_REGENERATION_WARNING =
  'This estimate has already been sent to the customer. Regenerating it will update the document using the current cart, and the previously sent version may no longer match. You may need to resend the revised estimate. Continue?';

export const resolveSentDocumentRegenerationState = ({ docType, activeDoc, workflowStage } = {}) => {
  const activeDocStatus = String(activeDoc?.status ?? '').trim().toLowerCase();
  const normalizedWorkflowStage = String(workflowStage || '').trim().toLowerCase();
  const hasActiveDocStatus = activeDocStatus.length > 0;

  return {
    isEstimateSentDoc:
      docType === 'estimate' && (
        activeDocStatus === '1_sent' ||
        activeDocStatus === 'sent' ||
        (!hasActiveDocStatus && normalizedWorkflowStage === 'estimate sent')
      ),
    // Agreement rules intentionally remain unchanged.
    isAgreementSentDoc:
      docType === 'sales-order' &&
      activeDocStatus === '2' &&
      normalizedWorkflowStage === 'agreement sent',
  };
};

export const confirmSentEstimateRegeneration = (
  isEstimateSentDoc,
  confirmFn = window.confirm
) => !isEstimateSentDoc || confirmFn(SENT_ESTIMATE_REGENERATION_WARNING);
